var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.notes),function(note){return _c('NoteItem',{key:note.id,attrs:{"note":note,"renaming":_vm.isRenaming(note.id)},on:{"note-selected":_vm.onNoteSelected,"start-renaming":_vm.onStartRenaming}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }